var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dataReady)?_c('div',{staticClass:"survey-personname"},[_c('b-button',{class:_vm.textClass,attrs:{"disabled":_vm.readOnly},on:{"click":function($event){return _vm.inputChanged()}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }